import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { id: 'home', label: '홈' },
    { id: 'intro', label: '센터 소개' },
    { id: 'programs', label: '상담 프로그램' },
    { id: 'counselors', label: '상담사 안내' },
    { id: 'booking', label: '상담예약' },
    { id: 'location', label: '오시는 길' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || menuOpen ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <div className="flex items-center justify-between">
          {/* 로고 */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('home')}>
            <span className={`text-[18px] md:text-[28px] font-extrabold tracking-tight transition-colors duration-300 whitespace-nowrap ${isScrolled || menuOpen ? 'text-[#8FA088]' : 'text-white'}`}>
              닥터리즈 심리상담센터
            </span>
          </div>

          {/* PC 메뉴 */}
          <div className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-[13px] font-medium text-[#2C2C2C] hover:text-[#A8B5A0] transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* 모바일 햄버거 버튼 */}
          <button
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 gap-1.5 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="메뉴 열기"
          >
            <span className={`block w-6 h-0.5 transition-all duration-300 ${isScrolled || menuOpen ? 'bg-[#2C2C2C]' : 'bg-white'} ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`block w-6 h-0.5 transition-all duration-300 ${isScrolled || menuOpen ? 'bg-[#2C2C2C]' : 'bg-white'} ${menuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 transition-all duration-300 ${isScrolled || menuOpen ? 'bg-[#2C2C2C]' : 'bg-white'} ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>
      </div>

      {/* 모바일 드롭다운 메뉴 */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="w-full text-left px-6 py-3.5 text-[14px] font-medium text-[#2C2C2C] hover:bg-[#F5F7F4] hover:text-[#8FA088] transition-colors cursor-pointer border-b border-gray-50 last:border-b-0"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
